import { styled } from '@mui/material/styles';
import { Badge } from '@mui/material';

interface StyledBadgeProps {
  pulse?: boolean;
}

export const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'pulse',
})<StyledBadgeProps>(({ theme, pulse }) => ({
  '& .MuiBadge-badge': {
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    minWidth: '20px',
    height: '20px',
    padding: theme.spacing(0, 0.5),
    
    ...(pulse && {
      animation: 'badge-pulse 2s infinite',
      
      '@keyframes badge-pulse': {
        '0%': {
          transform: 'scale(1)',
          opacity: 1,
        },
        '50%': {
          transform: 'scale(1.1)',
          opacity: 0.8,
        },
        '100%': {
          transform: 'scale(1)',
          opacity: 1,
        },
      },
    }),
  },
  
  '& .MuiBadge-dot': {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
  },
})); 